import { FETCH_DASHBOARD } from '../actionTypes';
import axios from 'axios';
import { hideLoader, showLoader } from './loader';

export const fetchDashboard = (query) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  return new Promise(async (respond, rej) => {
    dispatch(showLoader());
    await axios.get(`dashboard`, query).then(res => {
      dispatch({
        type: FETCH_DASHBOARD,
        payload: res.data
      });
      dispatch(hideLoader());
      respond(res.data);
    })
  });
}

export const fetchActiveList = (query) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  return new Promise(async (respond, rej) => {
    dispatch(showLoader());
    await axios.get(`brand/stats/activeList`, query).then(res => {
      dispatch(hideLoader());
      respond(res.data);
    })
  });
}

export const fetchActiveListRange = (query) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  return new Promise(async (respond, rej) => {
    dispatch(showLoader());
    await axios.get(`brand/stats/activeListRange`, query).then(res => {
      dispatch(hideLoader());
      respond(res.data);
    })
  });
}

export const fetchMonthlyList = (query) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  return new Promise(async (respond, rej) => {
    dispatch(showLoader());
    await axios.get(`brand/stats/activeListMonthly`, query).then(res => {
      dispatch(hideLoader());
      respond(res.data);
    })
  });
}




// WEBPACK FOOTER //
// ./src/store/actions/dashboards.js